const deriveTitleFromPath = (path: string, eventName: string): string => {
  const [, , pathPart] = path.match(/^\/events\/([a-z0-9]{16})\/([a-zA-Z0-9\-_]{1,})/) || [];
  //TODO: consider using i18n for titles.
  if (!pathPart) {
    return `Results Home - ${eventName}`;
  }
  switch (pathPart) {
    case 'following':
      return `Following - ${eventName}`;
    case `progress`:
      return `Event Progress Dashboard - ${eventName}`;
  }

  return 'Results - RaceRoster';
};

export default deriveTitleFromPath;
